import { render, staticRenderFns } from "./ElementTecnicTacticCrud.vue?vue&type=template&id=7b369e4a&scoped=true&"
import script from "./ElementTecnicTacticCrud.vue?vue&type=script&lang=js&"
export * from "./ElementTecnicTacticCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b369e4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
